import type { FC } from 'react'
import type { Dispatch } from 'react'
import { useReducer, useMemo } from 'react'
import { createContext } from 'react'

import type { Actions } from './actions'
import reducer from './reducer'
import { defaultState } from './state'
import type { State } from './state'

interface DispatchContext {
  dispatch?: Dispatch<Actions>
}

export const SignalRDispatchContext = createContext<DispatchContext>({})

interface StateContext {
  state: State
}

export const SignalRStateContext = createContext<StateContext>({ state: defaultState })

export const SignalRProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, defaultState)

  // We place dispatch and state in different providers to prevent
  // unecessary re-renders when calling dispatch.
  // See https://github.com/facebook/react/issues/15156

  const memoizedDispatch = useMemo(() => ({ dispatch }), [dispatch])
  const memoizedState = useMemo(() => ({ state }), [state])

  return (
    <SignalRDispatchContext.Provider value={memoizedDispatch}>
      <SignalRStateContext.Provider value={memoizedState}>
        {children}
      </SignalRStateContext.Provider>
    </SignalRDispatchContext.Provider>
  )
}
